import './drag-and-drop.scss';

export type DragAndDropProcessor<DragAndDropOutput = object> = {
  processDroppedFiles(files: FileList): ng.IPromise<DragAndDropOutput>;
  onDragAndDropSuccess(result: DragAndDropOutput): ng.IPromise<void>;
  onDragAndDropFailure(error: object): ng.IPromise<void>;
};

export type DragAndDropProps = {
  disable: boolean;
  showDndArea: boolean;
  processor?: DragAndDropProcessor;
};

export class DragAndDropController implements ng.IController, DragAndDropProps {

  public disable: boolean = false;
  public dragActive: boolean = false;
  public showDndArea: boolean = false;
  public processor?: DragAndDropProcessor;

  public areaVisible(): boolean {
    return !this.disable && (this.showDndArea || this.dragActive);
  }
}

export const DRAG_AND_DROP_NAME: string = 'dragAndDrop';

export const DragAndDropCreator: ng.IDirectiveFactory = ($q: ng.IQService): ng.IDirective => {
  return {
    template: require('./drag-and-drop.tpl.html'),
    restrict: 'E',
    scope: {
      disable: '<',
      showDndArea: '<',
      processor: '<',
    },
    controller: DragAndDropController,
    controllerAs: 'dndSupport',
    transclude: true,
    bindToController: true,
    link: ($scope: ng.IScope, element: JQLite, attrs: ng.IAttributes, ctrl?: ng.IController) => {
      const dndSupport: DragAndDropController = ctrl as DragAndDropController;
      element.addClass('drag-and-drop-root');
      element.on('dragover', (event: JQueryEventObject) => {
        event.stopPropagation();
        event.preventDefault();
        if (dndSupport.disable) {
          return;
        }
        const dragEvent: DragEvent = (event.originalEvent || event) as DragEvent;
        const dataTransfer: DataTransfer = dragEvent.dataTransfer as DataTransfer;
        dataTransfer.dropEffect = 'none';
        const { types: typeList } = dataTransfer;
        if (!typeList) {
          return;
        }
        const types: string[] = Array.prototype.slice.call(typeList).filter((type: string) => {
          return type.indexOf('Files') >= 0;
        });
        if (types.length < 1) {
          return;
        }
        dataTransfer.dropEffect = 'copy';
        $scope.$apply(() => dndSupport.dragActive = true);
      });
      element.on('dragleave', (e: JQueryEventObject) => {
        e.stopPropagation();
        e.preventDefault();
        if (dndSupport.disable) {
          return;
        }
        $scope.$apply(() => dndSupport.dragActive = false);
      });
      element.on('drop', (event: JQueryEventObject) => {
        event.preventDefault();
        if (dndSupport.disable) {
          return;
        }
        const dragEvent: DragEvent = (event.originalEvent || event) as DragEvent;
        const files: FileList = (dragEvent.dataTransfer as DataTransfer).files;
        if (!files || files.length <= 0) {
          $scope.$apply(() => dndSupport.dragActive = false);
          return;
        }
        const { processor: dragAndDropProcessor } = dndSupport;
        if (!dragAndDropProcessor) {
          $scope.$apply(() => dndSupport.dragActive = false);
          return;
        }
        dragAndDropProcessor.processDroppedFiles(files).then((result: object) => {
          dndSupport.dragActive = false;
          dragAndDropProcessor.onDragAndDropSuccess(result);
        }, (result: object) => {
          dndSupport.dragActive = false;
          dragAndDropProcessor.onDragAndDropFailure(result);
        });
      });
    },
  };
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0-0!./src/main/script/components/drag-and-drop/drag-and-drop.ts